module.exports = __webpack_public_path__ + "627a7e8ece265db413736bfae4a3060f.svg";